import React from 'react';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import insurerPic from './Images/HDFC_Life_Logo.svg.png';
import { CommaSeprator } from './UtilityComponents/UtilityFunction';


const InvestmentCompareBox = ({ CompareItem, Close, RemoveItemFromCompareBox, ShowCompareModel}) => {

    let history = useNavigate();


    
    return (
        <>
            <div className="InvestCompareMainPage">
                <div className="CompareBoxPage">

                    <div>
                        {CompareItem.map((item) => <div className="CompareItem">
                            <img src={item.Image} className="CompareItems" alt="" />
                            <div className="CompareItemPrice">
                                <span>{item.PlanName}</span>
                                <span className="ComparePrem">₹{CommaSeprator(item.NetPremium)} / {item?.PaymentFreq === "M" ? "Monthly" : item?.PaymentFreq === "H" ? "Half-Yearly" : item?.PaymentFreq === "Q" ? "Quarterly" : "Yearly"} </span>
                                <span className="ComparePremForFreq"></span> 
                                <p onClick={() => RemoveItemFromCompareBox(item.PlanName)} className="closebutton">
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" ><path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path></svg>
                                </p>
                            </div>
                        </div>)}
                    </div>
                    <div className="compareBtns">
                        <div onClick={() => ShowCompareModel(true)}>
                            {/*<button className={`SMCSmall ${CompareItem.length === 1 ?"disabled":""}`} disabled={CompareItem.length === 1} >Compare</button>*/}
                            <button className="QuoteBtn" disabled={CompareItem.length === 1} >Compare</button>
                        </div>

                        <button className="CompareClose" onClick={Close} >Close</button>
                    </div>
                    

                </div>
            </div>
            
        </>
    );
}
export default InvestmentCompareBox;
